import { ReactNode } from 'react'
import { generateUEID } from './ueid'

const formatErrorForToast = (error: unknown): ReactNode[] => {
  let errorString: string

  if (typeof error === 'string') {
    errorString = error
  } else if (error instanceof Error) {
    errorString = error.message
  } else {
    errorString = 'Unknown error'
  }

  return errorString.split('\n').map((er: string) => (
    <p className="mb-2 last:mb-0" key={generateUEID()}>
      {er}
    </p>
  ))
}

export default formatErrorForToast
